import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const fetchStores = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/stores`, auth);
  return response.data;
};

export const fetchStoreStats = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/stores/stats`, auth);
  return response.data;
};

export const fetchStoreGroups = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/stores/groups`, auth);
  return response.data;
};

export const createStoreGroup = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/groups`, payload, auth);
  return response.data;
};

export const getStoreById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/stores/${id}`, auth);
  return response.data;
};

export const createStore = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores`, payload, auth);
  return response.data;
};

export const updateStore = async (id, payload) => {
  const auth = getAuthHeaders();
  const response = await axios.put(`${BASE_URL}/api/stores/${id}`, payload, auth);
  return response.data;
};

export const deleteStore = async (id) => {
  const auth = getAuthHeaders();
  await axios.delete(`${BASE_URL}/api/stores/${id}`, auth);
  return id;
};

export const syncStoreProducts = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/products`, {}, auth);
  return response.data;
};

export const syncStoreOrders = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/orders`, {}, auth);
  return response.data;
};

export const syncStoreCustomers = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/customers`, {}, auth);
  return response.data;
};

export const syncStoreAll = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/all`, {}, auth);
  return response.data;
};

export const syncStoreInventory = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/inventory`, {}, auth);
  return response.data;
};

export const syncStoreCoupons = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/stores/${storeId}/sync/coupons`, {}, auth);
  return response.data;
};
